import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { DefaultRadio, DefaultRangePicker, MultiSelectInput, NumberInput, PasswordBox, TextInput, styleVariables } from '@lib/common';
import { ExpectationInputItem } from './expectation-input-item.component';
import { Form, InputNumber, Radio, Select, Skeleton, Switch } from 'antd';
import { FieldLabel } from '../field-label.component';
import styled, { css } from 'styled-components';
import { Duration, ScoreVisibilityType, UnixTimestamp } from '@module/assignment';
import { getPastTime, getSecurityRuleLabel } from '../../utils';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var verticalStyle = css([".ant-row{display:flex;flex-flow:row;align-items:center;.ant-col{max-width:50%;&:last-child{margin-left:10px;}}}.ant-form-item-label{padding:0px;text-align:left;}.ant-switch-checked{background-color:", ";}"], styleVariables.colors.blue6);
export var StyledRequiredMark = styled.span.withConfig({
  displayName: "base-optionscomponent__StyledRequiredMark",
  componentId: "sc-nlcd1i-0"
})(["color:", ";margin-left:4px;"], styleVariables.colors.red4);
export var StyledInputNumber = styled(InputNumber).withConfig({
  displayName: "base-optionscomponent__StyledInputNumber",
  componentId: "sc-nlcd1i-1"
})(["border-radius:8px;width:100%;"]);
export var InlineOption = styled(Form.Item).withConfig({
  displayName: "base-optionscomponent__InlineOption",
  componentId: "sc-nlcd1i-2"
})(["", " ", " ", ""], verticalStyle, function (props) {
  return props.isDropDown && "\n      margin-bottom: 0px;\n      margin-top: 12px;\n    ";
}, function (props) {
  return props.isSelectOnly && "\n      margin-bottom: 12px;\n      margin-top: 12px;\n    ";
});
var ExpectationInput = styled(NumberInput).withConfig({
  displayName: "base-optionscomponent__ExpectationInput",
  componentId: "sc-nlcd1i-3"
})(["border-radius:8px;width:100%;"]);
var StyledAutoBanOptionsRow = styled.div.withConfig({
  displayName: "base-optionscomponent__StyledAutoBanOptionsRow",
  componentId: "sc-nlcd1i-4"
})(["display:flex;gap:12px;align-items:center;"]);
var AutoBanOption = styled(InlineOption).withConfig({
  displayName: "base-optionscomponent__AutoBanOption",
  componentId: "sc-nlcd1i-5"
})([".ant-row{align-items:center;.ant-form-item-label{flex:1;width:85%;max-width:85%;text-align:left;}.ant-form-item-control{width:15%;flex-grow:unset;}}"]);
var StyledAvailableDurationSelectBox = styled(Select).withConfig({
  displayName: "base-optionscomponent__StyledAvailableDurationSelectBox",
  componentId: "sc-nlcd1i-6"
})([".ant-select-selector{border-radius:8px !important;}"]);
var StyledRadioGroup = styled(Radio.Group).withConfig({
  displayName: "base-optionscomponent__StyledRadioGroup",
  componentId: "sc-nlcd1i-7"
})(["display:flex;flex-direction:column;gap:12px;"]);
var StyledRadioOption = styled.div.withConfig({
  displayName: "base-optionscomponent__StyledRadioOption",
  componentId: "sc-nlcd1i-8"
})(["display:flex;flex-direction:column;gap:2px;"]);
var StyledRadioOptionHint = styled.span.withConfig({
  displayName: "base-optionscomponent__StyledRadioOptionHint",
  componentId: "sc-nlcd1i-9"
})(["margin-left:24px;font-size:12px;line-height:1.4;color:", ";"], styleVariables.colors.gray10);
export var renderTitleInput = function renderTitleInput(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.title,
      hint: label.titleHint,
      required: true
    }),
    name: "title",
    rules: [{
      required: true,
      message: errorLabel.notEmptyTitle
    }],
    children: /*#__PURE__*/_jsx(TextInput, {
      size: "middle",
      placeholder: label.title
    })
  });
};
export var renderDescriptionInput = function renderDescriptionInput(label) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.description,
      hint: label.descriptionHint
    }),
    name: "description",
    children: /*#__PURE__*/_jsx(TextInput, {
      size: "middle",
      placeholder: label.describeIntroduce
    })
  });
};
export var renderPasswordSwitchOption = function renderPasswordSwitchOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "hasPassword",
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.setPassword,
      hint: label.setPasswordHint
    }),
    initialValue: false,
    isDropDown: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderPasswordInput = function renderPasswordInput(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.setPassword,
      hint: label.setPasswordHint
    }),
    preserve: true,
    name: "password",
    rules: [{
      validator: function () {
        var _validator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, value) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(!value || value === '')) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", Promise.resolve());

                case 2:
                  if (!(value.length < 8)) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", Promise.reject(errorLabel.minPassword));

                case 4:
                  return _context.abrupt("return", Promise.resolve());

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function validator(_x, _x2) {
          return _validator.apply(this, arguments);
        }

        return validator;
      }()
    }],
    children: /*#__PURE__*/_jsx(PasswordBox, {
      size: "middle",
      placeholder: "".concat(label.inputPassword)
    })
  });
};
export var renderShuffleQuestionOption = function renderShuffleQuestionOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "isShuffleQuestion",
    valuePropName: "checked",
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.mixQuestions,
      hint: label.mixQuestionsHint
    }),
    initialValue: false,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderShuffleAnswerOption = function renderShuffleAnswerOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "isShuffleAnswer",
    valuePropName: "checked",
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.mixAnswers,
      hint: label.mixAnswersHint
    }),
    initialValue: false,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderShowExplanationSwitchOption = function renderShowExplanationSwitchOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "isShowingExplanationAndCorrectAnswers",
    valuePropName: "checked",
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.showExplanationAfterSubmit,
      hint: label.showExplanationAfterSubmitHint
    }),
    initialValue: true,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderShowExplanationRadioOptions = function renderShowExplanationRadioOptions(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.scoreVisibilityType,
      hint: label.scoreVisibilityTypeHint,
      required: true
    }),
    name: "scoreVisibilityType",
    initialValue: ScoreVisibilityType.manualPublishScore.value,
    rules: [{
      required: true,
      message: errorLabel.scoreVisibilityTypeIsRequired
    }],
    required: true,
    children: /*#__PURE__*/_jsxs(StyledRadioGroup, {
      children: [/*#__PURE__*/_jsxs(StyledRadioOption, {
        children: [/*#__PURE__*/_jsx(DefaultRadio, {
          value: ScoreVisibilityType.manualPublishScore.value,
          children: label.manualPublishScore
        }, ScoreVisibilityType.manualPublishScore.value), label.manualPublishScoreHint ? /*#__PURE__*/_jsx(StyledRadioOptionHint, {
          children: label.manualPublishScoreHint
        }) : null]
      }), /*#__PURE__*/_jsxs(StyledRadioOption, {
        children: [/*#__PURE__*/_jsx(DefaultRadio, {
          value: ScoreVisibilityType.immediateViewAfterSubmit.value,
          children: label.immediateViewAfterSubmit
        }, ScoreVisibilityType.immediateViewAfterSubmit.value), label.immediateViewAfterSubmitHint ? /*#__PURE__*/_jsx(StyledRadioOptionHint, {
          children: label.immediateViewAfterSubmitHint
        }) : null]
      })]
    })
  });
};
export var renderExpectationItem = function renderExpectationItem(label, errorLabel) {
  var isRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var formTotalScore = arguments.length > 3 ? arguments[3] : undefined;
  var onValuesChange = arguments.length > 4 ? arguments[4] : undefined;
  return /*#__PURE__*/_jsx(ExpectationInputItem, {
    label: label,
    errorLabel: errorLabel,
    isRequired: isRequired,
    formTotalScore: formTotalScore,
    onValuesChange: onValuesChange
  });
};
export var renderEnableSecurityOptionSwitchOption = function renderEnableSecurityOptionSwitchOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "hasSecurityOptions",
    valuePropName: "checked",
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.enableSecurityOption,
      hint: label.enableSecurityOptionHint
    }),
    initialValue: false,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderSecurityOptionSelection = function renderSecurityOptionSelection(isLoadingGetSecurityOptions, errorLabel, label, securityOptions) {
  if (isLoadingGetSecurityOptions || !securityOptions) {
    return /*#__PURE__*/_jsx(Skeleton.Input, {
      active: true
    });
  }

  var options = securityOptions.map(function (s) {
    return {
      id: s.id.toString(),
      value: s.id.toString(),
      label: label.securityRuleLabels ? getSecurityRuleLabel(s.key, label.securityRuleLabels, s.translation) : s.translation
    };
  });
  return /*#__PURE__*/_jsx(Form.Item, {
    noStyle: true,
    shouldUpdate: function shouldUpdate(prevValues, currentValues) {
      return prevValues.hasSecurityOptions !== currentValues.hasSecurityOptions;
    },
    children: function children(_ref) {
      var getFieldValue = _ref.getFieldValue;
      var hasSecurityOptions = getFieldValue('hasSecurityOptions');
      return hasSecurityOptions && /*#__PURE__*/_jsx(Form.Item, {
        label: /*#__PURE__*/_jsx(FieldLabel, {
          label: label.securityOptionSelection,
          hint: label.securityOptionSelectionHint,
          required: true
        }),
        required: true,
        name: "securityOptionIds",
        initialValue: securityOptions.map(function (s) {
          return s.id.toString();
        }),
        rules: [{
          validator: function () {
            var _validator2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_, values) {
              var isEmptySelection;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      isEmptySelection = values.length === 0;

                      if (!isEmptySelection) {
                        _context2.next = 3;
                        break;
                      }

                      return _context2.abrupt("return", Promise.reject(errorLabel.mustSelectAtLeastOneOption));

                    case 3:
                      return _context2.abrupt("return", Promise.resolve());

                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            function validator(_x3, _x4) {
              return _validator2.apply(this, arguments);
            }

            return validator;
          }()
        }],
        children: /*#__PURE__*/_jsx(MultiSelectInput, {
          mode: "multiple",
          allowClear: true,
          placeholder: label.securityOptionSelectionPlaceHolder,
          children: options.map(function (option) {
            return /*#__PURE__*/_jsx(Select.Option, {
              value: option.value,
              children: option.label
            }, option.id);
          })
        })
      });
    }
  });
};
export var renderSelectAvailableDurationOptions = function renderSelectAvailableDurationOptions(label) {
  var options = Duration.availableDurations.map(function (duration) {
    var isCustomDuration = duration === Duration.customDuration;

    if (isCustomDuration) {
      return {
        label: label.customDuration,
        value: Duration.customDuration
      };
    }

    return {
      label: "".concat(duration, " ").concat(label.minute),
      value: duration
    };
  });
  return /*#__PURE__*/_jsx(Form.Item, {
    name: "availableDuration",
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.durationAssignment,
      hint: label.durationHint,
      required: true
    }),
    initialValue: Duration.availableDurations[0],
    required: true,
    children: /*#__PURE__*/_jsx(StyledAvailableDurationSelectBox, {
      options: options
    })
  });
};
export var renderDurationInput = function renderDurationInput(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: label.durationAssignment,
      hint: label.durationHint,
      required: true
    }),
    name: "duration",
    initialValue: 30,
    dependencies: ['rangeDate', 'isUnlimitedAvailability'],
    required: true,
    rules: [{
      required: true,
      message: errorLabel.durationIsNotValid
    }, function (_ref2) {
      var getFieldValue = _ref2.getFieldValue;
      return {
        validator: function () {
          var _validator3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_, value) {
            var isValidRange, rangeDate, diffInMinutes;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    isValidRange = value && value < 1;

                    if (!isValidRange) {
                      _context3.next = 3;
                      break;
                    }

                    return _context3.abrupt("return", Promise.reject(errorLabel.durationIsNotValid));

                  case 3:
                    rangeDate = getFieldValue('rangeDate');

                    if (!(!getFieldValue('isUnlimitedAvailability') && rangeDate && rangeDate.length === 2 && value)) {
                      _context3.next = 8;
                      break;
                    }

                    diffInMinutes = moment(rangeDate[1]).startOf('minute').diff(moment(rangeDate[0]).startOf('minute'), 'minutes');

                    if (!(value > diffInMinutes)) {
                      _context3.next = 8;
                      break;
                    }

                    return _context3.abrupt("return", Promise.reject(errorLabel.durationMustLessThanDiffRangeOfStartAndEndTime));

                  case 8:
                    return _context3.abrupt("return", Promise.resolve());

                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function validator(_x5, _x6) {
            return _validator3.apply(this, arguments);
          }

          return validator;
        }()
      };
    }],
    children: /*#__PURE__*/_jsx(StyledInputNumber, {
      min: 1,
      addonAfter: label.minute
    })
  });
};
export var renderDatePickerByDurationSelection = function renderDatePickerByDurationSelection(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    noStyle: true,
    shouldUpdate: function shouldUpdate(prevValues, currentValues) {
      return prevValues.availableDuration !== currentValues.availableDuration || prevValues.rangeDate !== currentValues.rangeDate;
    },
    children: function children(_ref3) {
      var getFieldValue = _ref3.getFieldValue,
          setFieldValue = _ref3.setFieldValue;
      var availableDuration = getFieldValue('availableDuration');
      var isNotCustomDuration = availableDuration !== Duration.customDuration;
      var rangeDate = getFieldValue('rangeDate');

      if (availableDuration && isNotCustomDuration && rangeDate && rangeDate.length === 1) {
        var startTime = rangeDate[0];
        var endTime = moment(parseInt(UnixTimestamp.calculateFromDuration(startTime.unix() || Date.now(), parseInt(availableDuration))) * 1000);
        setFieldValue('rangeDate', [startTime, endTime]);
      }

      var customRules = [function (_ref4) {
        var getFieldValue = _ref4.getFieldValue;
        return {
          validator: function () {
            var _validator4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_, value) {
              var availableDuration, isNotCustomDuration, diffInMinutes;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      availableDuration = getFieldValue('availableDuration');
                      isNotCustomDuration = availableDuration !== Duration.customDuration;

                      if (!(value && value.length === 2 && isNotCustomDuration)) {
                        _context4.next = 6;
                        break;
                      }

                      diffInMinutes = moment(value[1]).startOf('minute').diff(moment(value[0]).startOf('minute'), 'minutes');

                      if (!(parseInt(availableDuration) !== diffInMinutes)) {
                        _context4.next = 6;
                        break;
                      }

                      return _context4.abrupt("return", Promise.reject(errorLabel.durationMustLessThanDiffRangeOfStartAndEndTime));

                    case 6:
                      return _context4.abrupt("return", Promise.resolve());

                    case 7:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            function validator(_x7, _x8) {
              return _validator4.apply(this, arguments);
            }

            return validator;
          }()
        };
      }];
      return renderCombinedDateRangePicker(label, errorLabel, 'rangeDate', ['availableDuration'], customRules);
    }
  });
};
export var renderCombinedDateRangePicker = function renderCombinedDateRangePicker(label, errorLabel) {
  var fieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rangeDate';
  var dependencies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var customRules = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  var disabledDate = function disabledDate(current) {
    return current && current < moment().startOf('day');
  };

  var disabledTime = function disabledTime(selectedDate) {
    return {
      disabledHours: !(selectedDate !== null && selectedDate !== void 0 && selectedDate.isAfter(moment.now(), 'days')) && function () {
        return getPastTime().hours;
      },
      disabledMinutes: !(selectedDate !== null && selectedDate !== void 0 && selectedDate.isAfter(moment.now(), 'days')) && function () {
        return getPastTime().minutes;
      }
    };
  };

  var defaultRules = [{
    required: true,
    message: errorLabel.selectDeadlineMessage
  }];
  var allRules = [].concat(defaultRules, _toConsumableArray(customRules));
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsx(FieldLabel, {
      label: "".concat(label.startTime, " - ").concat(label.endTime),
      hint: label.deadlineHint,
      required: true
    }),
    name: fieldName,
    dependencies: dependencies,
    rules: allRules,
    children: /*#__PURE__*/_jsx(DefaultRangePicker, {
      disabledDate: disabledDate,
      disabledTime: disabledTime,
      showTime: {
        format: 'HH:mm'
      },
      format: "DD/MM/YYYY - HH:mm",
      placeholder: [label.startTime, label.endTime]
    })
  });
};
export var renderExaminationDatePicker = function renderExaminationDatePicker(label, errorLabel) {
  var customRules = [function (_ref5) {
    var getFieldValue = _ref5.getFieldValue;
    return {
      validator: function () {
        var _validator5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_, value) {
          var timeAllotted, diffInMinutes;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  timeAllotted = getFieldValue('timeAllotted');

                  if (!(value && value.length === 2 && timeAllotted)) {
                    _context5.next = 5;
                    break;
                  }

                  diffInMinutes = moment(value[1]).startOf('minute').diff(moment(value[0]).startOf('minute'), 'minutes');

                  if (!(timeAllotted >= diffInMinutes)) {
                    _context5.next = 5;
                    break;
                  }

                  return _context5.abrupt("return", Promise.reject(errorLabel.durationMustLessThanDiffRangeOfStartAndEndTime));

                case 5:
                  return _context5.abrupt("return", Promise.resolve());

                case 6:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function validator(_x9, _x10) {
          return _validator5.apply(this, arguments);
        }

        return validator;
      }()
    };
  }];
  return renderCombinedDateRangePicker(label, errorLabel, 'rangeDate', ['timeAllotted'], customRules);
};
export var renderAutoBanOptions = function renderAutoBanOptions(label, errorLabel) {
  return /*#__PURE__*/_jsxs(StyledAutoBanOptionsRow, {
    children: [/*#__PURE__*/_jsx(Form.Item, {
      shouldUpdate: function shouldUpdate(prevValues, currentValues) {
        return prevValues.hasSecurityOptions !== currentValues.hasSecurityOptions;
      },
      noStyle: true,
      children: function children(_ref6) {
        var getFieldValue = _ref6.getFieldValue;
        var hasSecurityOptions = getFieldValue('hasSecurityOptions');
        return hasSecurityOptions && /*#__PURE__*/_jsx(AutoBanOption, {
          name: "shouldAutoBan",
          valuePropName: "checked",
          label: /*#__PURE__*/_jsx(FieldLabel, {
            label: label.shouldAutoBan,
            hint: label.shouldAutoBanHint
          }),
          initialValue: false,
          children: /*#__PURE__*/_jsx(Switch, {})
        });
      }
    }), /*#__PURE__*/_jsx(Form.Item, {
      noStyle: true,
      shouldUpdate: function shouldUpdate(prevValues, currentValues) {
        return prevValues.shouldAutoBan !== currentValues.shouldAutoBan;
      },
      children: function children(_ref7) {
        var getFieldValue = _ref7.getFieldValue;
        var shouldAutoBan = getFieldValue('shouldAutoBan');
        return shouldAutoBan && /*#__PURE__*/_jsx(Form.Item, {
          name: "maximumFoulsAllowed",
          initialValue: 1,
          required: true,
          rules: [{
            required: true,
            message: errorLabel.maxFoulsAllowedRequiredMessage
          }],
          children: /*#__PURE__*/_jsx(InputNumber, {
            addonAfter: label.maxFoulsAllowedSuffix,
            min: 1,
            placeholder: "1"
          })
        });
      }
    })]
  });
};